var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lxn-w100",style:(_vm.fullHeightStyle),attrs:{"id":"app"}},[_c('router-view'),(_vm.$store.state.appBusy)?_c('LoadingSpinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }